import { IconSearch } from "@tabler/icons-react";

type SearchButtonProps = {
  text: string; // Button text
  onClick?: () => void; // Click handler
  width?: string; // Width
  collapsed?: boolean; // Collapsed
};

export const SearchButton: React.FC<SearchButtonProps> = ({
  text,
  onClick,
  width = "w-full",
  collapsed = false,
}) => {
  return (
    <button
      type="button"
      className={`flex flex-row items-center w-full ${
        collapsed ? "justify-center" : "border"
      } ${width} body-3-regular py-2 font-tertiary surface-secondary rounded-lg outline-quaternary`}
      onClick={onClick}
    >
      <IconSearch size={16} className={collapsed ? "" : "ml-2 mr-1"} />
      {collapsed ? "" : text}
      {!collapsed && (
        <kbd className="ml-auto mr-2 hidden sm:flex items-center gap-0.5 rounded-md border px-1.5 py-0.5 body-4-regular font-tertiary outline-quaternary">
          <span>⌘</span>
          <span>K</span>
        </kbd>
      )}
    </button>
  );
};
